import { jsx as d, jsxs as h, Fragment as A } from "react/jsx-runtime";
import { c as M } from "react/compiler-runtime";
import { MenuItem as P, Menu as _ } from "@mui/material";
import { Avatar as j } from "../../atoms/Avatar/Avatar.js";
import "react";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../../molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../../molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import { Box as W } from "../../atoms/Box/Box.js";
import { Grid as G } from "../../atoms/Grid/Grid.js";
import { Typography as F } from "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "@mui/icons-material/Menu";
import "../SunburstGraph/SunburstGraph.js";
import "../RadarGraph/RadarGraph.js";
import "../ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "../ReactMap/index.js";
import "@mui/material/Button";
import "../ReactMap/GMapStatic.js";
import "../../../chunks/index.esm.js";
import "@mui/icons-material/Clear";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/material/Typography";
const Ii = (p) => {
  const t = M(36), {
    profile: o,
    menuOptions: y,
    anchorEl: u,
    setAnchorEl: v
  } = p, z = !!u;
  let m;
  t[0] !== v ? (m = () => v(null), t[0] = v, t[1] = m) : m = t[1];
  const L = o?.name || "";
  let r;
  if (t[2] !== L) {
    const E = L.trim();
    if (r = "?", E) {
      const g = E.split(/\s+/), I = g[0]?.[0] || "", k = g.length > 1 ? g[g.length - 1]?.[0] || "" : g[0]?.[1] || "", B = I + k;
      let C;
      t[4] !== B ? (C = B.toUpperCase(), t[4] = B, t[5] = C) : C = t[5], r = C || (I || "?").toUpperCase();
    }
    t[2] = L, t[3] = r;
  } else
    r = t[3];
  const R = o?.profilePicture || void 0;
  let T;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = {
    width: 40,
    height: 40,
    color: "white",
    bgcolor: "#878787",
    fontSize: 14,
    fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 600,
    letterSpacing: 0.2
  }, t[6] = T) : T = t[6];
  let b;
  t[7] !== r || t[8] !== R ? (b = /* @__PURE__ */ d(j, { src: R, sx: T, children: r }), t[7] = r, t[8] = R, t[9] = b) : b = t[9];
  const w = b;
  let e;
  t[10] !== o.name ? (e = /* @__PURE__ */ d(F, { sx: i.nameText, children: o.name }), t[10] = o.name, t[11] = e) : e = t[11];
  let l;
  t[12] !== o.role ? (l = /* @__PURE__ */ h(F, { sx: i.roleText, children: [
    "Role:",
    " ",
    o.role
  ] }), t[12] = o.role, t[13] = l) : l = t[13];
  let n;
  t[14] !== o.email ? (n = /* @__PURE__ */ d(F, { sx: i.emailText, children: o.email }), t[14] = o.email, t[15] = n) : n = t[15];
  let s;
  t[16] !== o.lastLoginTime ? (s = o.lastLoginTime && /* @__PURE__ */ d(F, { sx: i.lastLoginTimeText, children: `Last login: ${o.lastLoginTime}` }), t[16] = o.lastLoginTime, t[17] = s) : s = t[17];
  let a;
  t[18] !== n || t[19] !== s || t[20] !== e || t[21] !== l ? (a = /* @__PURE__ */ h(W, { children: [
    e,
    l,
    n,
    s
  ] }), t[18] = n, t[19] = s, t[20] = e, t[21] = l, t[22] = a) : a = t[22];
  let c;
  t[23] !== a || t[24] !== w ? (c = /* @__PURE__ */ h(G, { container: !0, sx: i.avatarContainer, children: [
    w,
    a
  ] }), t[23] = a, t[24] = w, t[25] = c) : c = t[25];
  let x;
  t[26] !== y ? (x = y?.map(U), t[26] = y, t[27] = x) : x = t[27];
  let f;
  t[28] !== c || t[29] !== x ? (f = /* @__PURE__ */ h(W, { sx: i.popupBox, children: [
    c,
    x
  ] }), t[28] = c, t[29] = x, t[30] = f) : f = t[30];
  let S;
  return t[31] !== u || t[32] !== z || t[33] !== f || t[34] !== m ? (S = /* @__PURE__ */ d(A, { children: /* @__PURE__ */ d(_, { id: "simple-menu", anchorEl: u, open: z, sx: i.container, onClose: m, children: f }) }), t[31] = u, t[32] = z, t[33] = f, t[34] = m, t[35] = S) : S = t[35], S;
}, i = {
  container: {
    "& .MuiPaper-root": {
      borderRadius: "8px",
      boxShadow: "0px 1px 20px 0px rgba(219, 219, 219, 1)"
    }
  },
  menuItem: {
    borderTop: "1px solid #EFEFEF",
    padding: "6px 8px",
    gap: "8px",
    fontSize: "12px",
    color: "#374151",
    "& svg": {
      width: "16px",
      height: "16px",
      color: "rgb(0, 0, 0, 0.6)"
    },
    "&:hover": {
      borderRadius: "4px"
    }
  },
  popupBox: {
    padding: "16px",
    paddingTop: "10px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column"
  },
  avatarContainer: {
    minWidth: "250px",
    alignItems: "center",
    gap: "16px",
    background: "#F7F7F7",
    padding: "8px",
    marginBottom: "22px",
    borderRadius: "8px",
    flexWrap: "nowrap",
    fontFamily: "Roboto, sans-serif"
  },
  nameText: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#141414"
  },
  roleText: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#878787",
    textTransform: "capitalize"
  },
  emailText: {
    fontSize: "12px",
    color: "#878787"
  },
  lastLoginTimeText: {
    marginTop: "4px",
    fontSize: "11px",
    color: "#878787"
  }
};
function U(p, t) {
  return /* @__PURE__ */ h(P, { sx: {
    ...i.menuItem,
    ...p.style
  }, onClick: p.onClick, children: [
    p.icon,
    p.text
  ] }, t);
}
export {
  Ii as default
};
